import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';

import * as styles from './NewbuildingCompareButton.css';

export function CompareOnboardingContent() {
  return (
    <div className={styles['onboarding-content']}>
      <UIText2 color="text-inverted-default">Сравнивайте ЖК от застройщиков по параметрам</UIText2>
    </div>
  );
}
